import React, { useContext, useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title as ChartTitle,
  Tooltip,
  Legend,
} from 'chart.js';
import {
  PageContent,
  PageSection,
  PageHeader,
  ControlContainer,
  ControlContainerRow,
} from 'common/styles/page';
import ToggleControl from '../../../common/components/ToggleChartControl';
import AnalyticsOverviewBar from './AnalyticsOverviewBar';
import AnalyticsOverviewHeat from './AnalyticsOverviewHeat';
import TopBarControls from 'common/layouts/AuthLayout/TopBarAssessmentPeriod';
import { useSelector } from 'react-redux';
import { getCurrentOrganizationId } from '../../../common/selectors/auth';
import { TopBarContext } from 'common/layouts/AuthLayout/TopBarContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, ChartTitle, Tooltip, Legend);

const AnalyticsOverview = () => {
  const [chartType, setChartType] = useState('radar');
  const organizationId = useSelector(getCurrentOrganizationId);
  const { setTopBarContent } = useContext(TopBarContext);

  useEffect(() => {
    setTopBarContent(<TopBarControls />);
    return () => setTopBarContent(null);
  }, [setTopBarContent, organizationId]);

  return (
    <PageContent>
      <PageSection>
        <PageHeader
          title="Organization Summary"
          caption="Overall culture score breakdown by demographic and comparison to the last assessment."
          controls={
            <ControlContainerRow>
              <ControlContainer justify="left">
                <ToggleControl
                  buttonLabels={[
                    { type: 'radar', icon: 'asterisk' },
                    { type: 'bar', icon: 'chart bar' },
                    { type: 'heat', icon: 'th' },
                  ]}
                  setChartType={setChartType}
                />
              </ControlContainer>
            </ControlContainerRow>
          }
        />
      </PageSection>
      {chartType === 'bar' ? (
        <AnalyticsOverviewBar type="bar" />
      ) : chartType === 'radar' ? (
        <AnalyticsOverviewBar type="radar" />
      ) : chartType === 'heat' ? (
        <AnalyticsOverviewHeat />
      ) : null}
    </PageContent>
  );
};

export default AnalyticsOverview;
